import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { Redirect, Route, type RouteProps } from 'react-router';
import type { Subscription } from 'rxjs';

import * as authService from '../services/authentication';
import { AuthStatus, type Roles } from '~/types/types';

export interface AuthPathProps {
  roles: Readonly<Roles[]>;
}

type AuthPathWithRouterProps = AuthPathProps & RouteProps;

export default function AuthPath({ roles, component, ...rest }: AuthPathWithRouterProps) {
  const [authStatus, setAuthStatus] = useState<AuthStatus>(AuthStatus.Uninitialized);

  useEffect(() => {
    const statusSub: Subscription = authService.getAuthStatusObs(roles).subscribe(setAuthStatus);

    return () => {
      statusSub.unsubscribe();
    };
  }, [roles]);

  let render;

  switch (authStatus) {
    case AuthStatus.Authorized:
      render = (props: any) => React.createElement(component!, props);
      break;
    case AuthStatus.AuthorizedTemporaryPassword:
      if (rest.path === '/account') {
        render = (props: any) => React.createElement(component!, props);
      } else {
        render = (props: any) => <Redirect to="/account" />;
      }
      break;
    case AuthStatus.Unauthorized:
      render = (props: any) => <Typography>Du saknar behörighet för att visa denna sida</Typography>;
      break;
    case AuthStatus.Unauthenticated:
      render = (props: any) => (
        <Redirect
          to={{
            pathname: '/login',
            state: { loginTo: window.location.pathname },
          }}
        />
      );
      break;
    default:
      render = (props: any) => <Typography>Laddar...</Typography>;
  }

  return <Route {...rest} render={render} />;
}
